/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState
     */
    country_id?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'country_id': json['country_id'] == null ? undefined : json['country_id'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoStateToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerScreenerLeadInfoState | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'code': value['code'],
        'country_id': value['country_id'],
    };
}

